import { Backdrop, CircularProgress, Modal } from '@material-ui/core/'
import { RightTableUnc } from '@root-gipro/modules/userProjects/components/Project/UncAdd/RightTableUnc'
import { SelectTable } from '@root-gipro/modules/userProjects/components/Project/UncAdd/SelectTable'
import { UncList } from '@root-gipro/modules/userProjects/components/Project/UncAdd/UncList'
import { IUncAddPannelProps } from '@root-gipro/modules/userProjects/models/interfaces/project-unc-add.props'
import {
	clearBuffer,
	deleteUnc,
	fetchUncs,
	fetchUserProject,
	getAssistStatus,
	selectTableElem,
	setAssistStatus,
	setFilter,
	setProjectUncs,
	setUncEditMode,
	setUncFullInfo,
} from '@root-gipro/modules/userProjects/store/actions'
import '@root-gipro/modules/userProjects/styles/UncAdd.scss'
import { PrimaryBtn, SecondaryBtn } from '@root-gipro/shared/Button/Button'
import { IState } from '@root-gipro/store/interfaces/state'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AssistantToggle from './AssistantToggle'
import Directions from './Directions'
import UncAddAssist from './UncAddAssist'

const UncAddPannel: React.FC<IUncAddPannelProps> = ({ uncEditMode, userSettings }) => {
	const [showDirections, setShowDirections] = useState(false)
	const [lastAssistState, setLastAssistState] = useState<any>(null)

	const { uncTableData, uncAddBuffer, uncs, projectObj, uncFullInfo, loadingAddUnc, uncCheckedTable } = useSelector(
		(state: IState) => state.userProjects
	)
	const { enableUncAssist } = useSelector((state: IState) => state.userProjects)

	const dispatch = useDispatch()
	useEffect(() => {
		try {
			if (userSettings && typeof userSettings.enableUncAssist !== 'undefined') {
				dispatch(setAssistStatus(userSettings.enableUncAssist))
			}
		} catch (error) {
			console.error('Failed to set assist status:', error)
		}
	}, [userSettings?.enableUncAssist])

	useEffect(() => {
		dispatch(getAssistStatus())
	}, [])

	useEffect(() => {
		if (uncFullInfo?.uncCellAssist) {
			setLastAssistState(uncFullInfo.uncCellAssist)
		}
	}, [uncFullInfo])

	// Эффект для обеспечения отображения ассистента при наличии расценок в буфере
	useEffect(() => {
		// Если буфер не пуст, но нет состояния ассистента, создаем пустое состояние
		if (uncAddBuffer.length > 0 && !uncFullInfo?.uncCellAssist && !lastAssistState && enableUncAssist) {
			// Создаем минимальное состояние, чтобы ассистент мог отобразиться
			setLastAssistState({
				requiredUncCellIds: [],
				recommendUncCellIds: [],
				duplicateUncCellIds: '',
			})
		}
		// Если буфер пуст, сбрасываем lastAssistState
		else if (uncAddBuffer.length === 0) {
			setLastAssistState(null)
		}
	}, [uncAddBuffer, uncFullInfo, lastAssistState, enableUncAssist])

	const cancelHandler = () => {
		dispatch(selectTableElem(null))
		uncAddBuffer.forEach((elem: any) => dispatch(deleteUnc(elem.id, true)))
		dispatch(setFilter(''))
		dispatch(setUncEditMode(false))
	}
	const readyHandler = () => {
		const clone = uncs.slice()
		uncAddBuffer.forEach(item => {
			if (!clone.some(cloneItem => cloneItem.id === item.id)) {
				clone.push(item)
			}
		})
		dispatch(setProjectUncs(clone))
		if (uncAddBuffer.length > 0) {
			dispatch(fetchUserProject(projectObj.id!))
		}
		dispatch(clearBuffer())
		dispatch(selectTableElem(null))
		dispatch(setFilter(''))
		dispatch(setUncEditMode(false))

		if (projectObj.id) dispatch(fetchUncs(projectObj.id))
	}
	useEffect(() => {
		if (uncEditMode) {
			dispatch(setUncFullInfo(null))
		}
	}, [uncEditMode])

	const handleOffAssist = () => {
		// При отключении ассистента просто сбрасываем состояние ассистента,
		// но не удаляем расценки - они могут все еще быть полезны пользователю
		dispatch(setUncFullInfo(null))
		// Установим lastAssistState в null, чтобы не восстанавливать ассистент
		setLastAssistState(null)
	}

	// Определяем, есть ли расценки в буфере для отображения переключателя
	const shouldShowToggle = uncAddBuffer.length > 0

	// Определяем, есть ли данные для отображения ассистента
	const hasAssistData = Boolean(uncFullInfo?.uncCellAssist || lastAssistState)

	return (
		<Modal
			aria-labelledby='transition-modal-title'
			aria-describedby='transition-modal-description'
			open={uncEditMode}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{
				timeout: 500,
			}}
		>
			<div className='unc_add_wrapper'>
				<Directions
					showDirections={showDirections}
					text={uncTableData?.note ? uncTableData.note : ''}
					closeHandler={() => setShowDirections(false)}
				/>
				<div className='scroll-wrapper'>
					<div className='unc_add unc_add_container' style={{ filter: showDirections ? 'blur(4px)' : '' }}>
						<UncList />
						<div className='wrapper-select-table'>
							<SelectTable setShowDirections={(show: boolean) => setShowDirections(show)} />
						</div>
						<div className='aside'>
							<div className='aside_top'>
								{/* Показываем переключатель, если есть расценки в буфере */}
								{shouldShowToggle && userSettings && <AssistantToggle handleOffAssist={handleOffAssist} />}
								<div>Переместите в</div>
								<RightTableUnc uncAddBuffer={uncAddBuffer} deleteUnc={id => dispatch(deleteUnc(id, true))} />
								{/* Показываем ассистент, если есть данные для него и он включен */}
								{enableUncAssist && hasAssistData && userSettings && (
									<UncAddAssist
										uncAddBuffer={uncAddBuffer}
										uncCellAssist={uncFullInfo?.uncCellAssist || lastAssistState}
									/>
								)}
							</div>
							<div className='action_btns mt-8 aside_bottom'>
								<PrimaryBtn variant='contained' onClick={readyHandler}>
									Готово
								</PrimaryBtn>
								<SecondaryBtn variant='contained' onClick={cancelHandler} className='rej_btn'>
									Отмена
								</SecondaryBtn>
							</div>
						</div>
					</div>
				</div>
				<Backdrop style={{ zIndex: 9999 }} open={loadingAddUnc}>
					<CircularProgress color='primary' />
				</Backdrop>
			</div>
		</Modal>
	)
}
export default UncAddPannel
